import { COLLECT_REPORT } from '@/api/apiModules'
export default {
  viewType: 'form',
  module: COLLECT_REPORT,
  needFetchFillInfo: false,
  params: null,
  toolbar: {},
  callBackAction: 'EnvCollectReportSuccess',
  extraParams: null,
  formatData(data) {
    data.terminal.forEach(item => {
      if (!item.memory) {
        item.memory = 0
      }
      if (!item.diskSize) {
        item.diskSize = 0
      }
      if (!item.diskCount) {
        item.diskCount = 0
      }
    })
    data.terminalList = data.terminal
    delete data.terminal
    return data
  },
  view: {
    title: '添加客户终端环境信息',
    labelPosition: 'right',
    labelWidth: '165px',
    width: '550px',
    content: [
      {
        $id: 'customer',
        $type: 'input',
        label: '客户名称',
        rules: [
          {
            notEmpty: '客户不能为空'
          }
        ]
      },
      {
        $id: 'customerPosition',
        $type: 'input',
        label: '客户岗位',
        rules: [
          {
            notEmpty: '客户岗位不能为空'
          }
        ]
      },
      {
        $id: 'terminal',
        $type: 'sky-report-terminal-relate',
        label: '客户现网终端收集'
      },
      {
        $id: 'peripherals',
        $type: 'sky-report-peripheral-relate',
        label: '外设'
      },
      {
        $id: 'software',
        $type: 'sky-report-software-relate',
        label: '软件'
      }
    ]
  }
}
